<h2 mat-dialog-title class="dialog-title">
  <mat-icon>style</mat-icon>
  <span>Allocations</span>
  <button mat-icon-button (click)="load()">
    <mat-icon>refresh</mat-icon>
  </button>

  <span class="spacer"></span>
  <button mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  <app-allocation-groups-list
    [allocations]="allocations"
    [loading]="loading"
    emptyMessage="No allocations for this contract yet.">
  </app-allocation-groups-list>
</mat-dialog-content>
